import AgreementTypePage from "./AgreementTypePage";

export default AgreementTypePage;